
import GeoreferencedSearchPlate from "./georeferenced-search-plate.jsx";
import ColorPicker from "../../../../components/color-picker/color-picker.jsx";
import {useContext} from "react";
import {FaChevronLeft, FaChevronRight} from "react-icons/fa";
import clsx from "clsx";
import {GeoreferencedSearchContext} from "../context/georeferenced-search-context.jsx";
import {regionType, resolveGridColor} from "../utils/georeferenced-search-utils.js";
import GeoreferencedSearchImgModal from "./georeferenced-search-img-modal.jsx";
import GeoreferencedSearchMobileDetails from "./georeferenced-search-mobile-details.jsx";

const API_URL = import.meta.env.VITE_API_URL;
const GeoreferencedSearchPassageDetail = ({className, replicatedPlates}) => {
    const {colorRegistry, gridApi, setRegistryVersion, options, currentPassage, detailController, selection} = useContext(GeoreferencedSearchContext);

    const colors = [
        '#C10625',
        '#FF5733',
        '#FFC300',
        '#4CAF50',
        '#2196F3',
        '#009688',
        '#9C27B0',
        '#E91E63',
    ]

    const details = options.groupByPlate
        ? selection.data?.passages?.[currentPassage]
        : selection.data;

    if (!details) return null;

    const onChangeColor = (newColor) => {
        if (!selection.data?.id) return;

        const registry = colorRegistry.current;

        if (options.groupByPlate) {
            registry.grouped.set(selection.data.id, newColor);
            selection.data.passages.forEach(el => {
                registry.default.set(el.id, newColor);
            })
        } else {
            registry.default.set(selection.data.id, newColor);
            registry.grouped.set(selection.data.plate.rawValue, newColor);
        }

        gridApi.current?.refreshCells({
            columns: ['pcl'],
            force: true
        })

        setRegistryVersion(v => v + 1);
    };

    const currentColor = resolveGridColor(selection.data, colorRegistry, options, replicatedPlates);

    return(
        <div className={className}>
            <div className="flex flex-col items-center">
                <div className="flex w-full justify-center">
                    { details.isFromCortex ?
                        <span className="text-center">{details.capturePlaceName}</span> :
                        <>
                            <img src={regionType[details.routeRegionType]}
                                 style={{height: "16px", width: "17px", marginRight: "4px"}}
                            />
                            <span className="font-bold leading-[14px]">{details.capturePlaceName}</span>
                        </>
                    }
                </div>
                {details.laneCode && <span>{`${details.laneCode} - ${details.routeName}`}</span>}
                <div className="w-[calc(100%-2rem)] border-b border-b-[#d9dada] my-2 relative">
                    { details.metadata && details.metadata.deviceinfo && <GeoreferencedSearchMobileDetails mobileInfo={details.metadata}/>}
                </div>
                <div className="flex w-full justify-center items-center px-4">
                    {options.groupByPlate && selection.data.passages.length > 1 &&
                        <span title="Passagem anterior"
                              className={clsx("mr-16", currentPassage === 0 ? "cursor-not-allowed" : "cursor-pointer")}
                              onClick={() => detailController('PREVIOUS')}><FaChevronLeft/></span>
                    }
                    <span>{details.dtCapture}</span>
                    {options.groupByPlate && selection.data.passages.length > 1 &&
                        <span title="Próxima passagem"
                              className={clsx("ml-16", currentPassage === (selection.data.passages.length - 1) ? "cursor-not-allowed" : "cursor-pointer")}
                              onClick={() => detailController('NEXT')}><FaChevronRight/></span>
                    }
                </div>
                {details.imageUrl ? <GeoreferencedSearchImgModal details={details} className="px-4 py-2"/> :
                    <img className={"px-4 py-2 opacity-[0.5]"} src={`${API_URL}//public/assets/img/sentry.imgnotfound.large.748x480.png`}/>
                }
                <GeoreferencedSearchPlate plate={details.plate}/>
                <div className="w-[calc(100%-2rem)] border-b border-b-[#d9dada] my-2"></div>
                <div className="w-[calc(100%-2rem)]">
                    <ColorPicker key={options.groupByPlate
                                    ? `${selection.data?.id}-${currentPassage}`
                                    : selection.data?.id
                                }
                                label="Cor do marcador"
                                 color={currentColor}
                                 labelClassName="font-bold text-[14px]"
                                 presetColors={colors} size={{height: 26, width: 26}}
                                 setColor={onChangeColor}/>
                </div>
            </div>
        </div>
    )
}

export default GeoreferencedSearchPassageDetail;